export const getBlogCategoryUrl = (categoryId: string) => {
return `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/category/${categoryId}`;
};

export const getBlogPostUrl = (postSlug: string) => {
return `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/${postSlug}`;
};

export const getBlogTagUrl = (tagId: string) => {
return `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/tag/${tagId}`;
};

export const getBlogPageUrl = (page: number) => {
return `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/page/${page}`;
};

export const getBlogAuthorUrl = (authorSlug: string) => {
return `/${process.env.NEXT_PUBLIC_BLOG_SLUG}/${process.env.NEXT_PUBLIC_BLOG_AUTHOR_SLUG}/${authorSlug}`;
};

// Helper function to get author URL with special logic for Dr. Jeffrey Harmon
export const getAuthorUrl = (author: { slug: string; title: string } | null | undefined) => {
  if (!author) {
    // Default to Dr. Jeffrey Harmon if no author provided
    return '/about-us/meet-dr-harmon';
  }
  
  // Only show link for Dr. Jeffrey Harmon
  const isDrHarmon = author.slug === 'meet-dr-harmon' || author.title === 'Dr. Jeffrey Harmon';
  if (isDrHarmon) {
    return '/about-us/meet-dr-harmon';
  }
  
  return null; // No link for other authors for now
};
